import { useState, useEffect } from 'react';
import { Format } from './_components/Format.js'
import { Case } from './_components/Case.js'
import { View } from './_components/View.js'
import { Criteria } from './_components/Criteria.js'
import { ItWas } from './_components/ItWas.js'

import './App.css';

// Яндекс.Метрика
const useYandexMetrika = () => {
  useEffect(() => {
    (function (m, e, t, r, i, k, a) {
      m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments) };
      m[i].l = 1 * new Date();
      for (var j = 0; j < document.scripts.length; j++) { if (document.scripts[j].src === r) { return; } }
      k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js?id=108751796', 'ym');

    ym(108751796, 'init', {
      ssr: true,
      webvisor: true,
      clickmap: true,
      ecommerce: "dataLayer",
      referrer: document.referrer,
      url: location.href,
      accurateTrackBounce: true,
      trackLinks: true
    });
  }, []);
};

// Импорт изображений
import CSK from './assets/logos/CSK.svg';
import RANEPA from './assets/logos/RANEPA.svg'

import logo from './assets/logo.png'
// import calendar from './assets/hero/calendar.svg'
// import watch from './assets/hero/watch.svg'
import address from './assets/hero/address.svg'
import sponsors from './assets/hero/hakaton-sponsors.png'
import friflexLogo from './assets/logos/friflex-logo.png'
import friflex from './assets/friflex.svg';
import n1 from './assets/numbers/1.png';
import n2 from './assets/numbers/2.png';
import n3 from './assets/numbers/3.png';
import n4 from './assets/numbers/4.png';

const FeedbackIcon = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M37.9922 10H39.987V25.9975H37.9922V10Z' fill='#6A50FF' />
    <path d='M35.9976 25.9976H37.993V27.993H35.9976V25.9976Z' fill='#6A50FF' />
    <path d='M35.9976 8.00537H37.993V10.0008H35.9976V8.00537Z' fill='#6A50FF' />
    <path
      d='M33.9893 27.9922H35.9978V30.0007H33.9893V27.9922Z'
      fill='#6A50FF'
    />
    <path d='M33.9893 5.99756H35.9978V8.0061H33.9893V5.99756Z' fill='#6A50FF' />
    <path d='M31.9951 30H33.9905V31.9954H31.9951V30Z' fill='#6A50FF' />
    <path
      d='M31.9951 4.00146H33.9905V5.99688H31.9951V4.00146Z'
      fill='#6A50FF'
    />
    <path d='M29.9873 31.9946H31.9958V33.99H29.9873V31.9946Z' fill='#6A50FF' />
    <path
      d='M27.9922 15.9976H31.9949V20.0002H27.9922V15.9976Z'
      fill='#6A50FF'
    />
    <path
      d='M27.9922 1.99463H31.9949V4.00252H27.9922V1.99463Z'
      fill='#6A50FF'
    />
    <path
      d='M25.9976 33.9897H29.9871V35.9976H25.9976V33.9897Z'
      fill='#6A50FF'
    />
    <path
      d='M21.9951 35.9976H25.9978V37.9923H21.9951V35.9976Z'
      fill='#6A50FF'
    />
    <path
      d='M7.99247 37.9923V35.9976H5.9977V37.9923H4.00293V40.0002H21.9952V37.9923H7.99247Z'
      fill='#6A50FF'
    />
    <path
      d='M17.9922 15.9976H21.9949V20.0002H17.9922V15.9976Z'
      fill='#6A50FF'
    />
    <path d='M13.9897 0H27.9925V1.99477H13.9897V0Z' fill='#6A50FF' />
    <path
      d='M9.99951 1.99463H13.9891V4.00252H9.99951V1.99463Z'
      fill='#6A50FF'
    />
    <path
      d='M9.99959 33.9894H11.9944V31.9946H7.9917V35.9973H9.99959V33.9894Z'
      fill='#6A50FF'
    />
    <path d='M7.9917 15.9976H11.9944V20.0002H7.9917V15.9976Z' fill='#6A50FF' />
    <path
      d='M5.99756 4.00146H10.0002V5.99624H5.99756V4.00146Z'
      fill='#6A50FF'
    />
    <path d='M5.99756 30H7.99298V31.9954H5.99756V30Z' fill='#6A50FF' />
    <path
      d='M4.00293 27.9922H5.99835V30.0007H4.00293V27.9922Z'
      fill='#6A50FF'
    />
    <path d='M4.00293 5.99756H5.99835V8.0061H4.00293V5.99756Z' fill='#6A50FF' />
    <path d='M1.99512 25.9976H4.00366V27.993H1.99512V25.9976Z' fill='#6A50FF' />
    <path
      d='M1.99512 8.00537H4.00366V10.0008H1.99512V8.00537Z'
      fill='#6A50FF'
    />
    <path d='M0 10H1.99477V25.9975H0V10Z' fill='#6A50FF' />
  </svg>
);

// Компоненты для иконок технологий
const AIIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="15" stroke="#6A50FF" strokeWidth="2" />
    <circle cx="14" cy="16" r="2" fill="#6A50FF" />
    <circle cx="26" cy="16" r="2" fill="#6A50FF" />
    <path d="M14 27C17.5 31 22.5 31 26 27" stroke="#6A50FF" strokeWidth="2" strokeLinecap="round" />
    <path d="M11 11L7 7" stroke="#6A50FF" strokeWidth="2" strokeLinecap="round" />
    <path d="M29 11L33 7" stroke="#6A50FF" strokeWidth="2" strokeLinecap="round" />
    <path d="M20 9V5" stroke="#6A50FF" strokeWidth="2" strokeLinecap="round" />
    <path d="M5 20H9" stroke="#6A50FF" strokeWidth="2" strokeLinecap="round" />
    <path d="M31 20H35" stroke="#6A50FF" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const PuzzleIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 5H5V14C5 14 7 14 9 12C11 10 12 12 14 14V5Z" stroke="#6A50FF" strokeWidth="2"
      strokeLinejoin="round" />
    <path d="M26 5H35V14C35 14 33 14 31 12C29 10 28 12 26 14V5Z" stroke="#6A50FF" strokeWidth="2"
      strokeLinejoin="round" />
    <path d="M14 35H5V26C5 26 7 26 9 28C11 30 12 28 14 26V35Z" stroke="#6A50FF" strokeWidth="2"
      strokeLinejoin="round" />
    <path d="M26 35H35V26C35 26 33 26 31 28C29 30 28 28 26 26V35Z" stroke="#6A50FF" strokeWidth="2"
      strokeLinejoin="round" />
    <rect x="14" y="14" width="12" height="12" stroke="#6A50FF" strokeWidth="2" />
  </svg>
);

const CodeIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 14L8 20L15 26" stroke="#6A50FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M25 14L32 20L25 26" stroke="#6A50FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22 8L18 32" stroke="#6A50FF" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// Хук для обработки анимаций при скролле
function useScrollReveal() {
  useEffect(() => {
    const scrollRevealElements = document.querySelectorAll('.scroll-reveal');

    const revealOnScroll = () => {
      scrollRevealElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;

        // Элемент считается видимым, когда он находится на 80% выше нижней части экрана
        if (elementTop < windowHeight * 0.8) {
          element.classList.add('revealed');
        }
      });
    };

    // Первичная проверка при загрузке страницы
    revealOnScroll();

    // Добавляем обработчик события скролла
    window.addEventListener('scroll', revealOnScroll);

    return () => {
      window.removeEventListener('scroll', revealOnScroll);
    };
  }, []);
}

// Логика Cookies
const checkCookie = (name) => {
  if (typeof document === 'undefined') return false;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.startsWith(name + '=')) {
      return true;
    }
  }
  return false;
};

const setCookie = (name, value, days) => {
  if (typeof document === 'undefined') return;
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
};
const COOKIE_NAME = 'blogCookieConsentAccepted';
const COOKIE_DURATION_DAYS = 14
// Компонент Cookie
const CookieConsent = () => {

  const [isVisible, setIsVisible] = useState(false); // Start as false, check cookie in useEffect

  useEffect(() => {
    if (!checkCookie(COOKIE_NAME)) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    setCookie(COOKIE_NAME, 'true', COOKIE_DURATION_DAYS);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookies">
      <div className="cookies__inner">
        <div className="cookies__text">
          <a className="cookies__link"
            href="/documents/cookies_policy.pdf"
            target="_blank">
            Мы используем файлы cookie.</a> Продолжая навигацию по сайту, вы соглашаетесь с правилами использования
          cookie.
        </div>
        <button className="cookies__apply" onClick={handleAcceptCookies} type="button">Ok</button>

      </div>
    </div>
  );
};

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Используем хук для анимаций при скролле
  useScrollReveal();

  // Инициализируем Яндекс.Метрику
  useYandexMetrika();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="app">
      <header className="header">
        <div className="container header-flex">
          <a href="#hero" className="header-logo">
            <img src={logo} alt="logo" />
          </a>
          <nav className="header-nav">
            <ul className="header-menu">
              <li><a href="#format" className="header-link">Формат</a></li>
              <li><a href="#criteria" className="header-link">Критерии</a></li>
              <li><a href="#case" className="header-link">Кейс</a></li>
              <li><a href="#tech" className="header-link">Технологии</a></li>
              <li><a href="#schedule" className="header-link">Программа</a></li>
              {/*<li>*/}
              {/*  <a target="_blank" href="https://forms.yandex.ru/cloud/69de56fd1f1eb50ea2b8b4cc"*/}
              {/*    className="primary__button">Принять*/}
              {/*    участие</a>*/}
              {/*</li>*/}
            </ul>
          </nav>
          <div className="header-burger" onClick={toggleMenu}>
            {isMenuOpen ? '✕' : '☰'}
          </div>
        </div>
        <nav className={`header-mobile-menu${isMenuOpen ? ' active' : ''}`}>
          <ul>
            <li><a href="#format" className="header-link" onClick={toggleMenu}>Формат</a></li>
            <li><a href="#criteria" className="header-link" onClick={toggleMenu}>Критерии</a></li>
            <li><a href="#case" className="header-link" onClick={toggleMenu}>Кейс</a></li>
            <li><a href="#tech" className="header-link" onClick={toggleMenu}>Технологии</a></li>
            <li><a href="#schedule" className="header-link" onClick={toggleMenu}>Программа</a></li>
            {/*<li>*/}
            {/*  <a target="_blank" href="https://forms.yandex.ru/cloud/69de56fd1f1eb50ea2b8b4cc"*/}
            {/*    className="primary__button">Принять*/}
            {/*    участие</a>*/}
            {/*</li>*/}
          </ul>
        </nav>
      </header>

      <main className="main-content">
        {/* Hero секция */}
        {/*<section className="hero" id="hero">*/}
        {/*  <div className="container hero-flex">*/}
        {/*    <div className="hero-content fade-in">*/}
        {/*      <h1 className="hero__title">*/}
        {/*        Vibe-*/}
        {/*      </h1>*/}
        {/*      <h2 className="hero__subtitle">*/}
        {/*        хакатон 2026*/}
        {/*      </h2>*/}
        {/*      <p className="hero__text">Первый хакатон по вайб-кодингу</p>*/}
        {/*      <CountdownTimer/>*/}

        {/*      <div className="hero-details">*/}
        {/*        <div className="hero-detail delay-1">*/}
        {/*          <span className="hero-icon"><CalendarIcon/></span>*/}
        {/*          <span>23 мая, 2026</span>*/}
        {/*        </div>*/}
        {/*        <div className="hero-detail delay-1">*/}
        {/*          <span className="hero-icon"><ClockIcon/></span>*/}
        {/*          <span>17:00 - 22:00</span>*/}
        {/*        </div>*/}
        {/*        <div className="hero-detail delay-2">*/}
        {/*          <span className="hero-icon"><LocationIcon/></span>*/}
        {/*          <span>МАИ</span>*/}
        {/*        </div>*/}
        {/*        <div className="hero-detail delay-2">*/}
        {/*          <span className="hero-icon"><OfflineIcon/></span>*/}
        {/*          <span>Offline</span>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*      <a href="https://forms.yandex.ru/cloud/69de56fd1f1eb50ea2b8b4cc" target="_blank"*/}
        {/*         rel="noopener noreferrer" className=" primary__button pulse delay-3">*/}
        {/*        Принять участие*/}
        {/*      </a>*/}

        {/*    </div>*/}
        {/*    <div>*/}
        {/*      <div className="hero-image-wrapper">*/}
        {/*        <img src={heroImage} alt="Vibe-хакатон 2026" className="hero-image"/>*/}
        {/*      </div>*/}
        {/*      <div className="hero-logo-box">*/}
        {/*        <img src={require('./assets/hero/friflex.jpg')} alt='friflex'*/}
        {/*             className="hero-logo--friflex"/>*/}
        {/*        X*/}
        {/*        <img src={require('./assets/hero/mai.png')} alt='mai' className="hero-logo"/>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</section>*/}
        <section className="hero" id="hero">
          <div className="container">
            <div className="hero__wrapper">
              <div className="hero__wrapper-header">
                <img src={sponsors} alt="sponsors" className='hide-mob' />
                <img src={friflexLogo} alt="sponsors" className='mob' />
              </div>
              <div className="hero__wrapper-body">
                <h1>Вайбатон</h1>
                <h2>Хакатон с использованием вайб-кодинга</h2>
                {/*<a target="_blank" href="https://forms.yandex.ru/cloud/69de56fd1f1eb50ea2b8b4cc"*/}
                {/*  className="primary__button">Принять*/}
                {/*  участие</a>*/}
                {/*<div className="hero__info hide-mob calendar">*/}
                {/*  <img src={calendar} alt="calendar" />*/}
                {/*  <span>28.04.2026</span>*/}
                {/*</div>*/}
                {/*<div className="hero__info hide-mob watch">*/}
                {/*  <img src={watch} alt="watch" />*/}
                {/*  <span>15:00-22:00</span>*/}
                {/*</div>*/}
                <div className="hero__info hide-mob address">
                  <img src={address} alt="address" />
                  <span>РАНХиГС, Проспект Вернадского, 82</span>
                </div>
                <div className="hero__info hide-mob text">
                  <span>GenAI x продукт<br /> x креатив</span>
                </div>
              </div>
            </div>
            <div className='hero__info-wrapper'>
              {/*<div className="hero__info calendar">*/}
              {/*  <img src={calendar} alt="calendar" />*/}
              {/*  <span>28.04.2026</span>*/}
              {/*</div>*/}
              <div className="hero__info address">
                <img src={address} alt="address" />
                <span>РАНХиГС, Проспект Вернадского, 82</span>
              </div>
              {/*<div className="hero__info watch">*/}
              {/*  <img src={watch} alt="watch" />*/}
              {/*  <span>15:00-22:00</span>*/}
              {/*</div>*/}
              <div className="hero__info text">
                <span>GenAI x продукт<br /> x креатив</span>
              </div>
              {/*<a target="_blank" href="https://forms.yandex.ru/cloud/69de56fd1f1eb50ea2b8b4cc"*/}
              {/*  className="primary__button">Принять*/}
              {/*  участие</a>*/}
            </div>
          </div>
        </section>
        {/*<section className="friflex" id='friflex'>*/}
        {/*  <div className="container">*/}
        {/*    <div className="friflex-inner">*/}
        {/*      /!*<img src={laptop} alt={'laptop'} className="friflex-image"/>*!/*/}

        {/*      <div className="friflex__txt">*/}
        {/*        <p>Компания Friflex внимательно следит за мировыми технологическими трендами, и вайб-кодинг*/}
        {/*          является одним из*/}
        {/*          самых ярких на сегодняшний день. </p>*/}
        {/*        <p>Это возможность предоставить клиентам лучшие технологические решения, которые есть на*/}
        {/*          сегодняшний день. Часто*/}
        {/*          это дает возможность лидерства: по скорости, качеству и уникальному функционалу. </p>*/}
        {/*      </div>*/}
        {/*      <div className="friflex__txt-svg">*/}
        {/*        <div className="friflex__txt">*/}
        {/*          <p>Благодаря многолетней экспертизе в разработке высоконагруженных мобильных сервисов,*/}
        {/*            продуктов с искусственным*/}
        {/*            интеллектом, команда Friflex может быстро понять, какие плюсы и минусы несет новая*/}
        {/*            технология. </p>*/}
        {/*          <p>Поэтому для клиентов риски внедрения новых инструментов уже сняты: опыта и*/}
        {/*            профессионализма*/}
        {/*            Friflex хватает,*/}
        {/*            чтобы быстро разобраться и предложить лучший вариант использования.</p>*/}

        {/*        </div>*/}
        {/*        <CupIcon/>*/}
        {/*      </div>*/}

        {/*      <div className="friflex__petr">*/}
        {/*        <div className="comment-item">*/}
        {/*          <img*/}
        {/*            src={require('./assets/petr.png')}*/}
        {/*            alt="P2etr"*/}
        {/*            className="comment-item__img"*/}
        {/*          />*/}
        {/*          <div>*/}
        {/*            <p className="comment-item__txt">«Мы видим, что вайб-кодинг начинает активно*/}
        {/*              использоваться разработчиками. Мы считаем, что этот инструмент действительно*/}
        {/*              может ускорять решение отдельных задач. Нам важно действовать на опережение и*/}
        {/*              собрать на российском рынке комьюнити энтузиастов, кто будет первыми пробовать*/}
        {/*              этот метод на реальных технологических задачах. Поэтому мы решили, что*/}
        {/*              проведение вайбатона – это лучший способ проверить возможности вайб-кодинга в*/}
        {/*              действии и объединить заинтересованных партнеров».*/}
        {/*            </p>*/}
        {/*            <strong className="comment-item__author">Петр Чернышев, генеральный директор*/}
        {/*              Friflex</strong>*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}

        {/*  </div>*/}
        {/*</section>*/}

        <Format />
        <Case />
        <View />
        <section className="actions">
          <div className='container'>
            <h3 className='section-title'>Что нужно сделать</h3>
            <ul className="case-list need-list">
              <li className="case-item box-white">
                <img src={n1} alt='1' />
                Собрать MVP-сервис для удобной генерации контента на трибуны.
              </li>
              <li className="case-item box-white">
                <img src={n2} alt='2' />
                Собрать MVP-сервис для удобной генерации контента на трибуны.
              </li>
              <li className="case-item box-white">
                <img src={n3} alt='3' />Подготовить понятный результат и презентацию.
              </li>
              <li className="case-item box-white">
                <img src={n4} alt='4' />
                Выступить с защитой перед жюри.
              </li>
            </ul>
          </div>

        </section>
        <Criteria />

        {/* Секция "Технологии" */}
        <section className="tech" id="tech">
          <div className="container">
            <h2 className="section-title scroll-reveal">Что можно использовать</h2>
            <div className="tech-items scroll-reveal">
              <div className="tech-item">
                <div className="tech-icon"><AIIcon /></div>
                <div className="tech-name">ИИ-ассистенты для кода</div>
                <p>Claude, Cursor, Codex, Copilot и другие</p>
              </div>
              <div className="tech-item">
                <div className="tech-icon"><PuzzleIcon /></div>
                <div className="tech-name">Модели генерации картинок</div>
                <p>Nano Banana, DALL·E, Flux, Stable Diffusion и другие</p>
              </div>
              <div className="tech-item">
                <div className="tech-icon"><CodeIcon /></div>
                <div className="tech-name">Язык и фреймворки на выбор</div>
                <p>Python, TypeScript, Go и другие по решению команды</p>
              </div>
            </div>
          </div>
        </section>
        <ItWas />
        {/* Секция "Отзывы" */}
        <section className='feedback'>
          <div className='container'>
            <h2 className='section-title scroll-reveal'>Отзывы</h2>
            <div className='feedback-container'>
              <div className='feedback-card'>
                <div>
                  <FeedbackIcon />
                </div>

                <div>
                  <p>
                    Спасибо большое организаторам, жюри и участникам за
                    вайбатон! Нам очень понравилось в МАИ, получилось
                    действительно вайбово, все, с кем познакомились, вы
                    классные, ну и призы оригинальные очень, неожиданно прям)
                    Зарядили эмоциями, спасибо еще раз за крутой день!
                  </p>
                  <span>Светлана Шубина, студентка МИСИС</span>
                </div>
              </div>
              <div className='feedback-card'>
                <div>
                  <FeedbackIcon />
                </div>
                <div>
                  <p>
                    Мы успешно разработали три базовые игровые механики —
                    раннер, кликер и квиз — и реализовали пять уровней, каждый
                    из которых отражает реальные страховые случаи в 2D. Гордимся
                    тем, что за короткий срок нам удалось собрать,
                    протестировать и презентовать работающее решение, которое
                    уже демонстрирует потенциал для масштабирования.
                  </p>
                  <span>Никита Серый, студент МАИ</span>
                </div>
              </div>
              <div className='feedback-card'>
                <div>
                  <FeedbackIcon />
                </div>
                <div>
                  <p>
                    Несмотря на трудности, команда научилась быстро тестировать
                    гипотезы и предложения, отказываться от неработающих
                    решений, комбинировать AI с ручным контролем, фокусироваться
                    на MVP, отсекая второстепенные функции.
                  </p>
                  <span>Александр Кретов, студент МАИ</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Секция "Juri" */}
        <section className="jury" id="jury">
          <div className="container">
            <h2 className="section-title">
              Эксперты
            </h2>
            <div className="jury-list">
              <div className='jury-list-row jury-list-row-1'>
                <div className="jury-card">
                  <h4 className="jury-card__name">
                    Пётр Чернышев
                  </h4>
                  <p className="jury-card__position">
                    CEO, Friflex
                  </p>
                  <img
                    src={require('./assets/jury/jury-1.png')}
                    alt="Пётр Чернышев"
                    className="jury-card__img"
                  />
                </div>
                <div className="jury-card">
                  <h4 className="jury-card__name">
                    Петр Щербаков
                  </h4>
                  <p className="jury-card__position">
                    CTO, Friflex
                  </p>
                  <img
                    src={require('./assets/jury/jury-10.png')}
                    alt="Петр Щербаков"
                    className="jury-card__img"
                  />
                </div>
                <div className="jury-card">
                  <h4 className="jury-card__name">
                    Алена Тавберидзе
                  </h4>
                  <p className="jury-card__position">
                    Эксперт по развитию команд и руководителей. Тренер Бизнес-ТРИЗ
                  </p>
                  <img
                    src={require('./assets/jury/2026/jury1.jpg')}
                    alt="Алена Тавберидзе"
                    className="jury-card__img"
                  />
                </div>
                <div className="jury-card">
                  <h4 className="jury-card__name">
                    Хохрин Егор
                  </h4>
                  <p className="jury-card__position">
                    Руководитель отдела развития цифровых сервисов ЦСКА
                  </p>
                  <img
                    src={require('./assets/jury/2026/jury2.jpg')}
                    alt="Хохрин Егор"
                    className="jury-card__img"
                  />
                </div>
                <div className="jury-card">
                  <h4 className="jury-card__name">
                    Маруев Сергей
                  </h4>
                  <p className="jury-card__position">
                    Заместитель директора института, кандидат технических наук
                  </p>
                  <img
                    src={require('./assets/jury/2026/jury3.jpg')}
                    alt="Маруев Сергей"
                    className="jury-card__img"
                  />
                </div>
                <div className="jury-card">
                  <h4 className="jury-card__name">
                    Крутелев Егор
                  </h4>
                  <p className="jury-card__position">
                    Руководитель отдела по школьным, студенческим и социальным проектам ЦСКА
                  </p>
                  <img
                    src={require('./assets/jury/2026/jury4.jpg')}
                    alt="Крутелев Егор"
                    className="jury-card__img"
                  />
                </div>
                <div className="jury-card">
                  <h4 className="jury-card__name">
                    Фролов Михаил
                  </h4>
                  <p className="jury-card__position">
                    Руководитель CRM и программы лояльности ЦСКА
                  </p>
                  <img
                    src={require('./assets/jury/2026/jury5.jpg')}
                    alt="Фролов Михаил"
                    className="jury-card__img"
                  />
                </div>
                <div className="jury-card">
                  <h4 className="jury-card__name">
                    Александр Желубенков
                  </h4>
                  <p className="jury-card__position">
                    Руководитель отдела интеллектуального анализа данных и машинного обучения Lamoda Tech
                  </p>
                  <img
                    src={require('./assets/jury/2026/jury6.jpg')}
                    alt="Александр Желубенков"
                    className="jury-card__img"
                  />
                </div>
                <div className="jury-card">
                  <h4 className="jury-card__name">
                    Анна Жданова
                  </h4>
                  <p className="jury-card__position">
                    Руководитель управления электронной коммерции «Бристоль»
                  </p>
                  <img
                    src={require('./assets/jury/2026/jury7.jpg')}
                    alt="Анна Жданова"
                    className="jury-card__img"
                  />
                </div>
                <div className="jury-card">
                  <h4 className="jury-card__name">
                    Лешуков Олег
                  </h4>
                  <p className="jury-card__position">
                    Руководитель отдела развития цифровых продуктов и инноваций SYNERGETIC
                  </p>
                  <img
                    src={require('./assets/jury/2026/jury8.jpg')}
                    alt="Лешуков Олег"
                    className="jury-card__img"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Секция "Тайминг" */}
        <section className="schedule" id="schedule">
          <div className="container">
            <h2 className="section-title scroll-reveal">Программа</h2>
            <div className="timeline scroll-reveal">
              <div className="timeline-item">
                {/*<div className="timeline-time">15:00 – 15:30</div>*/}
                <div className="timeline-content">
                  <h3>Сбор участников</h3>
                  <p>Регистрация команд и подготовка к мероприятию</p>
                </div>
              </div>
              <div className="timeline-item">
                {/*<div className="timeline-time">15:30 – 15:45</div>*/}
                <div className="timeline-content">
                  <h3>Открытие хакатона и питчинг кейса</h3>
                  <p>Презентация задания и знакомство с правилами</p>
                </div>
              </div>
              <div className="timeline-item">
                {/*<div className="timeline-time">15:45 – 19:45</div>*/}
                <div className="timeline-content">
                  <h3>Работа над проектами с перерывом на перекус</h3>
                  <p>Активная фаза разработки с использованием ИИ-инструментов</p>
                </div>
              </div>
              <div className="timeline-item">
                {/*<div className="timeline-time">19:45 – 21:15</div>*/}
                <div className="timeline-content">
                  <h3>Питчинг проектов (5 минут на команду + вопросы жюри)</h3>
                  <p>Выступление с презентациями перед жюри</p>
                </div>
              </div>
              <div className="timeline-item">
                {/*<div className="timeline-time">21:15 – 21:45</div>*/}
                <div className="timeline-content">
                  <h3>Голосование жюри, подсчёт результатов</h3>
                  <p>Обсуждение и оценка решений</p>
                </div>
              </div>
              <div className="timeline-item">
                {/*<div className="timeline-time">21:45 – 22:00</div>*/}
                <div className="timeline-content">
                  <h3>Подведение итогов, награждение</h3>
                </div>
              </div>


            </div>
            <div className="comment-item-wrapper">
              <div className="comment-item">
                <img
                  src={require('./assets/petr.png')}
                  alt="P2etr"
                  className="comment-item__img"
                />
                <div>
                  <p className="comment-item__txt">«Мы видим, что вайб-кодинг начинает активно
                    использоваться разработчиками. Мы считаем, что этот инструмент действительно
                    может ускорять решение отдельных задач. Нам важно действовать на опережение и
                    собрать на российском рынке комьюнити энтузиастов, кто будет первыми пробовать
                    этот метод на реальных технологических задачах. Поэтому мы решили, что
                    проведение вайбатона – это лучший способ проверить возможности вайб-кодинга в
                    действии и объединить заинтересованных партнеров».
                  </p>
                  <strong className="comment-item__author">Петр Чернышев, генеральный директор
                    Friflex</strong>
                </div>
              </div>
              <div className="comment-item">
                <img
                  src={require('./assets/aleksandr-2.png')}
                  alt="Aleksandr"
                  className="comment-item__img"
                />
                <div>
                  <p className="comment-item__txt">
                    «Вайб-кодинг — это вызов привычному программированию. Это свобода мышления,
                    креатив и возможность делать больше за меньшее время. Для студентов и начинающих
                    разработчиков вайб-кодинг — это возможность с самого старта работать в новом
                    формате. Vibe-хакатон — отличная точка входа в это новое мышление».
                  </p>
                  <strong className="comment-item__author">
                    Александр Федотов <br />
                    Software Engineer, независимый эксперт.
                  </strong>
                </div>
              </div>

            </div>

          </div>
        </section>

        {/* Секция "Call to Action" */}
        <section className="cta" id="cta">
          <div className="container">
            <h2 className="section-title scroll-reveal">Готов к вайб-кодингу?</h2>
            <div className="cta-content scroll-reveal">
              <div className="cta-inner">
                <img src={require('./assets/ready.png')} alt="ready" className="cta-logo" />
                <div>
                  <p className="cta-text">Собирай команду и присоединяйся к первому в России хакатону
                    по
                    вайб-кодингу. Проверь свои навыки работы с ИИ, создай инновационный проект и
                    выиграй
                    призы!</p>
                  {/*<a href="https://forms.yandex.ru/cloud/69de56fd1f1eb50ea2b8b4cc" target="_blank"*/}
                  {/*  rel="noopener noreferrer" className=" primary__button pulse">*/}
                  {/*  Принять участие*/}
                  {/*</a>*/}
                </div>
              </div>

            </div>
          </div>
        </section>
        {/* Секция "Партнеры" */}
        <section className="partners" id="partners">
          <div className="container">
            <h2 className="section-title scroll-reveal">Партнеры</h2>
            <div className="organizers-content scroll-reveal">

              <div className="organizer-card">
                <img src={CSK} alt="cofe"
                  className="organizer-logo cofe-logo" />
                <p className="organizer-description">
                  Один из старейших и самых титулованных российских клубов
                </p>
              </div>

              <div className="organizer-card">
                <img src={RANEPA} alt="crossConf" className="organizer-logo crossconf-logo" />
                <p className="organizer-description">
                  Российская академия народного хозяйства и государственной службы при Президенте РФ
                </p>
              </div>

            </div>
          </div>
        </section>
        {/* Секция "Организаторы" */}
        <section className="organizers" id="organizers">
          <div className="container">
            <h2 className="section-title scroll-reveal">Организаторы</h2>
            <div className="organizers-content scroll-reveal flex">
              <a href="https://friflex.com/" target="_blank" rel="noopener noreferrer">
                <div className="organizer-card">
                  <img src={friflex} alt="Friflex"
                    className="organizer-logo organizer-logo-friflex" />
                  <p className="organizer-description">
                    ИИ-решения, мобильные приложения и сайты
                    для миллионов пользователей
                  </p>
                </div>
              </a>
            </div>
          </div>
        </section>
      </main>

      {/* Футер */}
      <footer className="footer">
        <div className="container footer-container">
          <div className="footer-logo">Vibe-хакатон 2026</div>
          <div className="footer-contact">
            <span>Остались вопросы?</span>
            <a href="mailto:vibeathon@friflex.com">vibeathon@friflex.com</a>
          </div>
          <div className="footer-links">
            <a
              href="/documents/privacy-policy.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link">
              Политика конфиденциальности
            </a>
            <a
              href="/documents/public-offer.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link">
              Публичная оферта
            </a>

          </div>
        </div>
        <div className="container footer-container">
          <p className='footer-text'>
            Общество с ограниченной ответственностью «Фрифлекс». <br />
            Адрес местонахождения: 127030, г. Москва, вн. тер. г. муниципальный округ Тверской, ул. Сущёвская, д. 27, стр. 2, помещ. 4Б/2.<br />
            ИНН: 7726434385.<br />
            ОГРН: 1187746579789.<br />
            Основной код ОКВЭД: 62.01.<br />
            Email: hello@friflex.com  Телефон: +7 (495) 131-54-96<br />
            Дополнительные коды ОКВЭД: 46.51.2, 58.29, 62.02.1, 62.02.2, 62.02.4, 62.02.9, 62.03, 62.09, 63.11, 63.12, 63.99.1, 72.19
          </p>
        </div>
        <CookieConsent />

      </footer>
    </div>
  );
}

export default App;